import { Button } from '@app/components/various/Button';
import { isNull } from '@app/utils/is';
import { useTranslation } from 'react-i18next';

import { useDatePickerSelectionContext } from '../context';

interface Props {
  variant?: 'text' | 'ghost';
}
export const DatePickerClearButton = ({ variant = 'ghost' }: Props) => {
  const { t } = useTranslation(['common']);
  const { startDate, resetSelection } = useDatePickerSelectionContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    resetSelection();
  };

  return (
    <Button color="secondary" variant={variant} disabled={isNull(startDate)} onClick={handleClick}>
      {t('common:clear')}
    </Button>
  );
};
